import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { BucketEmailStatus } from '../model';

interface BucketEmailStatusIconProps {
  status: BucketEmailStatus;
  // Controlled so the parent card can also open the tooltip on keyboard focus.
  tooltipOpen: boolean;
  onTooltipOpen: () => void;
  onTooltipClose: () => void;
}

const BucketEmailStatusIcon: React.FC<BucketEmailStatusIconProps> = ({
  status,
  tooltipOpen,
  onTooltipOpen,
  onTooltipClose,
}) => (
  <Tooltip title={status.reason} open={tooltipOpen} onOpen={onTooltipOpen} onClose={onTooltipClose}>
    {/* Off gets a thicker border + tint so a disabled bucket stands out at a glance. */}
    <Box
      role="img"
      aria-label={`Automated emails ${status.enabled ? 'on' : 'off'}: ${status.reason}`}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 28,
        height: 28,
        borderRadius: '50%',
        border: status.enabled ? 1 : 2,
        borderColor: status.enabled ? 'success.main' : 'error.main',
        color: status.enabled ? 'success.main' : 'error.main',
        bgcolor: (theme) => (status.enabled ? 'transparent' : alpha(theme.palette.error.main, 0.1)),
      }}
    >
      <EmailOutlinedIcon sx={{ fontSize: 16 }} />
    </Box>
  </Tooltip>
);

export default BucketEmailStatusIcon;
